import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    height: 0;\n    opacity: 0;\n    visibility: hidden;\n\n    ", ";\n\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            height: 100%;\n            opacity: 1;\n            visibility: inherit;\n            ", "\n            ", "\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        transition: all ", "s ease;\n        ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { transitionDurationInSec } from '../../../constants';
import { typography } from '../../../system/mixins';
import { getPropsBlocker } from '../../../utils';
var propertyList = {
  isExpanded: true
};

var accordionContentStyle = function accordionContentStyle(_ref) {
  var isExpanded = _ref.isExpanded,
      AccordionContent = _ref.theme.componentOverrides.AccordionContent;
  var base = css(_templateObject(), transitionDurationInSec, AccordionContent.Root.base);

  if (isExpanded) {
    return css(_templateObject2(), base, isExpanded ? AccordionContent.Root.expanded : '');
  }

  return base;
};

export var AccordionContentRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject3(), typography('paragraphLarge'), accordionContentStyle);